import apiClient from '../apiClient';
import { GET_TEMPLATE_EXCURSION_PRICE_DATA_URL } from '../apiUrl';

const getTemplateExcursionPriceApi = () => {
  return apiClient.get(GET_TEMPLATE_EXCURSION_PRICE_DATA_URL);
};

export default getTemplateExcursionPriceApi;
